import { AirQualityContent } from './AirQualityContent';
import { useExternalAirQualityData } from '../../../hooks/air/useExternalAirQualityData';

export const OutdoorAirQualityContent: React.FC = () => {
  const { qualityData: outdoorQualityData } = useExternalAirQualityData();

  const outdoorAQI = outdoorQualityData.value;
  const label = `${outdoorAQI} - AQI`;

  return <AirQualityContent qualityData={outdoorQualityData} label={label} />;
};
